import moment from 'moment'

export default class WheelDomain {
	/**
	 * Handles the default constructor
	 * @param {string} diameter - wheel diameter
	 * @param {string} offset - offset position
	 * @param {string} material - material
	 * @param {string} wheelType - wheel type
	 * @param {string} colorFinish - color/finish
	 * @param {string} comments - comments
	 * @param {number} id - id
	 * @param {boolean} isCreate - in create mode
	 * @param {boolean} isUpdate - in update mode
	 * @param {boolean} isDelete - in delete mode
	 * @param {boolean} isBillToPreference - is this from the bill-to account
	 * @param {boolean} isReadOnly - is this object readOnly
	 * @param {string} createdAt - created date
	 * @param {string} updatedAt - updated date
	 * @returns {WheelDomain} - returns the new WheelDomain object
	 */
	constructor(diameter, offset, material, wheelType, colorFinish, comments, id, isBillToPreference, isReadOnly, createdAt, updatedAt) {
		this.diameter = diameter
		this.offset = offset || offset === 0 ? offset : ''
		this.material = material 
		this.wheelType = wheelType 
		this.colorFinish = colorFinish || ''
		this.comments = comments ? comments : ''
		this.id = id 
		this.isCreate = false
		this.isUpdate = false
		this.isDelete = false
		this.isBillToPreference = isBillToPreference
		this.isReadOnly = isReadOnly
		this.createdAt = moment(createdAt)
		this.updatedAt = moment(updatedAt)
	}
}


// WEBPACK FOOTER //
// ./src/domains/WheelDomain.js